import React from "react";
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import 'katex/dist/katex.min.css';
import { BlockMath, InlineMath } from 'react-katex';

function Calculationcomponent({ results, inputData }) {
  if (!results || Object.keys(results).length === 0) {
    return <div>No results to display yet.</div>;
  }

  const activeResults = results.activeResults

  const loadcurrent = inputData.loadCurrent
  const deratingfactor = activeResults?.Derating?.[activeResults.Derating.length - 1]?.[1]?.[0];
  const lengthofrun = inputData?.lengthOfCable
  const PF = inputData?.powerFactor
  const voltage = inputData?.supplyVoltage
  const activetriptime = inputData?.faulttriptime
  // Extracting values
  const Active_cable_size = activeResults?.selectedCableSize;
  const Active_cable_mode = inputData?.activeCableSizingMode;
  const Circuit_capacity_derated = activeResults?.currentCarryingCapacity?.circuitRatingDerated;
  const Circuit_capacity = activeResults?.currentCarryingCapacity?.circuitRating;
  const spare_capacity = Math.round(activeResults?.currentCarryingCapacity?.spareCapacity * 100) / 100;
  const number_of_active_circuits = activeResults?.number_of_circuits;
  const current_carrying_cap_ok = activeResults?.currentCarryingCapacity?.ok;


  const conductor_short_1s = Math.round(activeResults?.shortCircuitCapacity?.conductor_short_1s* 100) / 100;
  const screen_short_1s = Math.round(activeResults?.shortCircuitCapacity?.screen_short_1s* 100) / 100;
  const I_conductor_new = Math.round(activeResults?.shortCircuitCapacity?.I_conductor_new* 100) / 100;
  const I_screen_new = Math.round(activeResults?.shortCircuitCapacity?.I_screen_new* 100) / 100;

  
    return (
  <div className="App">
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems=""
          style={{ minHeight: "10vh",
              padding: "1.5rem",
           }}
        >
            <Grid item xs={12} sm={12} md={12}>
          <Paper
            elevation={6}
            style={{
              padding: "2.5rem",
              borderRadius: "20px",
              background: "#ffffff",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
            }}
          >

                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
                          <Typography variant="h3"          
                           sx={{
                            fontSize: { xs: "16px", md: "25px" }, // Adjust font size for subtitle
                            fontWeight: "700",
                            fontFamily: "'Hubballi', sans-serif",
                            letterSpacing: "1px",
                        }}> 
                            ACTIVE CABLE SIZE CALCULATION
                          </Typography>
                          
                        </Stack>

                          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        
                        
                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                letterSpacing: "1px",
                              }}
                        >
                          STEP ONE (CURRENT CARRYING CAPACITY CHECK)<br />
                        </Typography>
                          </Stack>

                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >
<BlockMath math={`I_{load} = ${loadcurrent}\\,A`} /> 
<BlockMath math={`Cable\\,Derated\\,Capacity = Cable\\,Capacity \\, \\times Derating Factor =  ${Circuit_capacity} \\times ${deratingfactor} = ${Circuit_capacity_derated}\\,A`} />
<BlockMath math={`Spare\\, Capacity\\, Available = ${Circuit_capacity_derated} - ${loadcurrent} = ${spare_capacity}\\,A`} />
                          
                          
                          </Typography>
                          
 

                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >

                          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        
                        
                             <Typography
                             sx={{
                                fontSize: { xs: "16px", md: "20px" },
                                fontWeight: "700",
                                fontFamily: "'Hubballi', sans-serif",
                                overflowX: 'auto',
                                letterSpacing: "1px",
                              }}
                        >
                          STEP TWO (SHORT CIRCUIT TEMPERATURE RISE)<br />
                        </Typography>
                          </Stack>

                           <Typography
                            sx={{
                              fontSize: { xs: "1.1rem", md: "1.1rem" },
                              fontWeight: "100",
                              fontFamily: "'Hubballi', sans-serif",
                              letterSpacing: "1px",
                              overflowX: 'auto',
                              lineHeight: 2,
                            }}
                          >

<BlockMath math={`Conductor \\ Short \\ Circuit \\ Rating\\ (For \\ 1 \\ Second) = \\sqrt\\frac{K^2 \\times S^2}{1} = ${conductor_short_1s}\\ kA`} />
<BlockMath math={`Conductor \\ Short \\ Circuit \\ Rating\\ (For \\ ${activetriptime} \\ Second) = \\frac{${conductor_short_1s}}{\\sqrt{${activetriptime}}} = ${I_conductor_new}\\ kA`} />
<BlockMath math={`Screen \\ Short \\ Circuit \\ Rating\\ (For \\ 1 \\ Second) = \\sqrt\\frac{K^2 \\times S^2}{1} = ${screen_short_1s}\\ kA`} />
<BlockMath math={`Conductor \\ Short \\ Circuit \\ Rating\\ (For \\ ${activetriptime} \\ Second) = \\frac{${screen_short_1s}}{\\sqrt{${activetriptime}}} = ${I_screen_new}\\ kA`} />
                      
                          </Typography>
                          </Typography>



                              

          </Paper>
          </Grid>


        </Grid>
        </div>
      );
}

export default Calculationcomponent;
